import React, { useState, useEffect } from "react";

import { IService, IServiceCategory } from "app/api/types";
import { Link } from "react-router-dom";

import "./styles.scss";

interface IProps {
  serviceCategoriesList: IServiceCategory[];
  service: IService;
  isActive: boolean;
  onSubmit: (data: IService) => void;
}

const EditServiceForm: React.FC<IProps> = props => {
  const [title, setTitle] = useState(props.service.title);
  const [duration, setDuration] = useState(props.service.duration);
  const [price, setPrice] = useState(props.service.price);
  const [description, setDescription] = useState(props.service.description);
  const [categoryId, setCategoryId] = useState(
    props.service.category_href?.split(".")[1]
  );
  const [errorStyle, setErrorStyle] = useState({
    price: "",
    duration: "",
    title: ""
  });

  const handleChange = (e: any) => {
    e.target.name === "title" && setTitle(e.target.value);
    e.target.name === "duration" && setDuration(e.target.value);
    e.target.name === "price" && setPrice(e.target.value);
    e.target.name === "description" && setDescription(e.target.value);
    e.target.name === "categoryId" && setCategoryId(e.target.value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (title.length > 1 && price > 1 && duration > 1)
      props.onSubmit({
        title,
        duration,
        price,
        description,
        id: props.service.id,
        categoryId: categoryId!,
        href: `service.${props.service.id}`
      });
  };

  useEffect(() => {
    setErrorStyle({
      price: price && price > 1 ? "" : "edit-phrase__input_error",
      title: title && title.length > 1 ? "" : "edit-phrase__input_error",
      duration:
        duration && duration > 1 && duration % 30 === 0
          ? ""
          : "edit-phrase__input_error"
    });
  }, [price, title, duration]);

  return (
    <form
      className={`edit-phrase__form ${props.isActive ? "active" : ""}`}
      onSubmit={handleSubmit}
    >
      <label htmlFor="phrase" className="edit-phrase__label">
        название услуги
      </label>
      <input
        className={`edit-phrase__input ${errorStyle.title}`}
        type="text"
        placeholder={title}
        name="title"
        value={title}
        onChange={handleChange}
        autoComplete="off"
      />
      {/* <label htmlFor="translation" className="edit-phrase__label">
        продолжительность в минутах (кратная 30)
      </label>
      <input
        className={`edit-phrase__input ${errorStyle.duration}`}
        type="text"
        placeholder={duration + ""}
        name="duration"
        value={duration}
        onChange={handleChange}
        autoComplete="off"
      /> */}
      <label htmlFor="meaning" className="edit-phrase__label">
        цена в руб.
      </label>
      <input
        className={`edit-phrase__input ${errorStyle.price}`}
        placeholder={price + ""}
        name="price"
        value={price}
        onChange={handleChange}
        autoComplete="off"
      />
      <label htmlFor="meaning" className="edit-phrase__label">
        Краткое описание.
      </label>
      <textarea
        className={`edit-phrase__input ${errorStyle.price}`}
        placeholder={"Напишите краткое описание к услуге"}
        name="description"
        value={description}
        onChange={handleChange}
        autoComplete="off"
      />

      <label className="edit-phrase__label mgt20">Категория услуги</label>
      <div className="category-block">
        {props.serviceCategoriesList.map(serviceCategory => {
          return (
            <div key={serviceCategory.id}>
              <input
                name="categoryId"
                type="radio"
                id={`${props.service.id}.${serviceCategory.id}`}
                value={serviceCategory.id}
                onChange={handleChange}
                defaultChecked={
                  serviceCategory.id ===
                  props.service.category_href?.split(".")[1]
                }
              />
              <label
                htmlFor={`${props.service.id}.${serviceCategory.id}`}
                className="category-block__label"
              >
                <p>{serviceCategory.title}</p>
              </label>
            </div>
          );
        })}
      </div>

      <button className="edit-phrase__submit">cохранить</button>

      <Link to={`pages/${props.service.service_href}`} key={props.service.id}>
        Редактировать страницу
      </Link>
    </form>
  );
};

export default EditServiceForm;
